module.exports = __webpack_public_path__ + "static/media/welcometitle.0adac3ff.png";